// extracted by mini-css-extract-plugin
module.exports = {"section":"_6c97079b1b--section--gmjAX"};